import { render, staticRenderFns } from "./CargoTableComponent.vue?vue&type=template&id=7fe6739e&"
import script from "./CargoTableComponent.vue?vue&type=script&lang=js&"
export * from "./CargoTableComponent.vue?vue&type=script&lang=js&"
import style0 from "./CargoTableComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports